module.exports = __webpack_public_path__ + "img/brand-empty.ac3528a8.png";